var map = {
	"./de.json": 392,
	"./en.json": 393,
	"./es.json": 394,
	"./fr.json": 395,
	"./it.json": 396,
	"./skins/class.it.json": 680,
	"./skins/default.en.json": 681,
	"./skins/education.de.json": 682,
	"./skins/education.en.json": 683,
	"./skins/education.es.json": 684,
	"./skins/education.fr.json": 685,
	"./skins/education.it.json": 686,
	"./skins/museum.de.json": 687,
	"./skins/museum.en.json": 688,
	"./skins/museum.es.json": 689,
	"./skins/museum.fr.json": 690,
	"./skins/museum.it.json": 691,
	"./tenants/ancot.it.json": 692,
	"./tenants/class.it.json": 693,
	"./tenants/csp.en.json": 694,
	"./tenants/csp.it.json": 695,
	"./tenants/ekom.it.json": 696
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 679;